/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import { BodyText, Icon } from '../../components/core';
import Colors from '../../constants/Colors';
import Links from '../../../data/Links';
import MediaQueries from '../../constants/MediaQueries';
import Review from '../../components/Review';
import type { ReviewType } from '../../../data/Reviews';

function ReviewsBlock({
  review,
  theme = 'light',
}: {
  theme?: 'light' | 'dark',
  review: ReviewType,
}) {
  return (
    <div style={{ textAlign: 'center', maxWidth: 880, margin: '0 auto' }}>
      <Review review={review} theme={theme} />
      <a href={Links.GoogleReviews}>
        <BodyText
          size="20"
          align="center"
          weight="medium"
          className={Styles.Link}
          color={Colors.Violet}>
          Read more customer reviews <Icon className={Styles.Icon} name="arrow-big-violet-right" />
        </BodyText>
      </a>
    </div>
  );
}

const Styles = {
  CarouselItem: css`
    width: 100%;
    ${MediaQueries.Medium} {
      padding: 0 30px;
    }
  `,
  Title: css`
    margin-bottom: 10px;
    display: inline-block;
  `,
  Link: css`
    margin-top: 32px;
    margin-bottom: 32px;
    margin-left: 0;
    margin-right: 0;
    vertical-align: middle;
  `,
  Icon: css`
    margin-left: 8px;
  `,
};

export default ReviewsBlock;



// WEBPACK FOOTER //
// ./src/ui/pages/components/ReviewBlock.js